module.exports = __webpack_public_path__ + "static/PMB_cloud_instructions-e703f42273d8a4b2564e9895932702ca.png";